export const OLD_NIGHTGRAPH_HOST = import.meta.env.VITE_OLD_NIGHTGRAPH_HOST;
export const MONOLITH_HOST = import.meta.env.VITE_MONOLITH_HOST;
export const BOOKING_PLUGING_HOST = import.meta.env.VITE_BOOKING_HOST;
export const XCEED_ROUTE: string = import.meta.env.VITE_MONOLITH_HOST ?? 'https://xceed.me';
export const EVENTS_SERVICE_ROUTE = import.meta.env.VITE_EVENTS_HOST;
export const OFFERS_SERVICE_ROUTE = import.meta.env.VITE_OFFERS_HOST;

export const ILL_BE_USER = '_Ill_be_user';

export const CLUB_SETTINGS_ROUTE = `${OLD_NIGHTGRAPH_HOST}/:lang/:city-slug/:companyId/:club-slug/setup/venue`;

export const OLD_EVENTS_DRAFT = `${OLD_NIGHTGRAPH_HOST}/:lang/:city-slug/:companyId/:club-slug/events/draft`;
export const EVENTS = `${OLD_NIGHTGRAPH_HOST}/:lang/:city-slug/:companyId/:club-slug/events/live`;
export const MARKETING_ROUTE = `${OLD_NIGHTGRAPH_HOST}/:lang/:city-slug/:companyId/:club-slug/promoters/performance`;

export const ANALYTICS_ROUTE = '/:companyId/:clubSlug/analytics';
export const CUSTOMERS_ROUTE = '/:companyId/:clubSlug/customers';
export const EVENT_LIST = '/:companyId/:clubSlug/events/:view';
export const INSIGHTS_ROUTE = '/:companyId/:clubSlug/insights';
export const ADD_VENUE_ROUTE = '/:companyId/:clubSlug/add-venue';
export const SELECT_VENUE_ROUTE = `/select-venue`;

export const USER_SETTINGS_ROUTE = `/user-settings`;
export const COMPANY_INFO_PATH = 'info';
export const COMPANY_EVENT_DEFAULTS_PATH = 'event-defaults';
export const COMPANY_INTEGRATIONS_PATH = 'integrations';
export const COMPANY_WIDGET_PATH = 'widget';
export const COMPANY_USERS_PATH = 'users';
export const COMPANY_BILLING_PATH = 'billing';
export const COMPANY_VENUES_PATH = 'venues';

export const USERS_ROUTE = `/:companyId/:clubSlug/company/${COMPANY_USERS_PATH}`;
export const USERS_DETAIL_ROUTE = `${USERS_ROUTE}/:userId`;
export const SUPPORT_ROUTE = 'https://support.xceed.me';
const PRESETS_ROUTE = '/:companyId/:clubSlug/offers';
const EVENTS_ROUTE = '/:companyId/:clubSlug/events';
export const COMPANY_ROUTE = '/:companyId/:clubSlug/company';
export const COMPANY_INFO_ROUTE = `${COMPANY_ROUTE}/${COMPANY_INFO_PATH}`;
export const COMPANY_EVENT_DEFAULTS_ROUTE = `${COMPANY_ROUTE}/${COMPANY_EVENT_DEFAULTS_PATH}`;
export const COMPANY_INTEGRATIONS_ROUTE = `${COMPANY_ROUTE}/${COMPANY_INTEGRATIONS_PATH}`;
export const COMPANY_WIDGET_ROUTE = `${COMPANY_ROUTE}/${COMPANY_WIDGET_PATH}`;
export const COMPANY_BILLING_ROUTE = `${COMPANY_ROUTE}/${COMPANY_BILLING_PATH}`;
export const COMPANY_VENUES_ROUTE = `${COMPANY_ROUTE}/${COMPANY_VENUES_PATH}`;
export const COMPANY_IMPORT_ROUTE = `/:companyId/:clubSlug/company/import/:importId/:importType`;
export const PRESET_LIST_ROUTE = `${PRESETS_ROUTE}/list`;
export const PRESET_FLOORPLAN_ROUTE = `${PRESETS_ROUTE}/floorplan/:floorplanId`;
export const BOOKING_DETAILS_HOLDERS_ROUTE = `${EVENTS_ROUTE}/:eventId/booking/:bookingId/:code`;
export const DUPLICATE_EVENT_INFO_ROUTE = `${EVENTS_ROUTE}/:eventId/duplicate/info`;
export const PROCESS_IMPORT_ROUTE = `${EVENTS_ROUTE}/:eventId/import/:importId/:importType`;
export const EVENT_EDIT_DETAILS_ROUTE = `${EVENTS_ROUTE}/:eventId/details`;
export const EVENT_CREATE_INFO_ROUTE = `${EVENTS_ROUTE}/info`;
export const EVENT_EDIT_INFO_ROUTE = `${EVENTS_ROUTE}/:eventId/info`;
export const BOOKING_DETAILS_ROUTE = `${EVENTS_ROUTE}/:eventId/booking/:bookingId`;
export const EVENT_PUBLISH_ROUTE = `${EVENTS_ROUTE}/:eventId/publish`;
export const EVENT_REPORT_ROUTE = `${EVENTS_ROUTE}/:eventId/report`;
export const INFO_POINT_ROUTE = `${EVENTS_ROUTE}/:eventId/info-point`;
export const OFFERS_ROUTE = `${EVENTS_ROUTE}/:eventId/offers`;
export const OFFERS_FLOORPLAN_ROUTE = `${OFFERS_ROUTE}/floorplan/:floorplanId`;

export const SHARE_PAYMENT_LINK_ROUTE = `${BOOKING_PLUGING_HOST}/:channel-slug/offer/:offerId`;

export const EVENT_REPORT_DOWNLOAD_PDF_ROUTE = `${MONOLITH_HOST}/ticket/:bookingToken`;
export const PREVIEW_URL_UNPUBLISHED_ROUTE = `${MONOLITH_HOST}/:lang/:city-slug/preview/event/:eventId/channel/:channel-slug`;
export const PREVIEW_URL_PUBLISHED_ROUTE = `${MONOLITH_HOST}/:lang/:city-slug/event/:event-slug/:eventId/channel/:channel-slug`;
export const PUBLIC_VENUE_URL_ROUTE = `${MONOLITH_HOST}/:lang/:city-slug/venue/:venue-slug`;
export const PUBLIC_ORGANIZER_URL_ROUTE = `${XCEED_ROUTE}/organizer/:slug`;
export const REDIRECT_URL = `${MONOLITH_HOST}/authenticate?platform=widget&redirectUrl`;
